import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';

import ReviewList from './components/ReviewList';

import './styles.scss';


const Reviews = (props) => {
  const {
    reviewForm, isLoggedIn, numReviews, canReview, loading, children,
  } = props;
  return (
    <section
      className={classNames(
        'reviews',
        numReviews && numReviews > 0 ? 'has-reviews' : 'no-reviews',
        isLoggedIn ? 'show-submit' : 'no-submit',
        isLoggedIn && canReview ? 'user-can-review' : 'user-cannot-review',
      )}
      styleName='reviews'
    >

      <h2>Reviews</h2>

      <div styleName='reviews-wrapper'>

        { isLoggedIn ? reviewForm : (
          <small className='text-muted'>
            <Link to='/user/register/'>
              Register
            </Link> or <Link to='/user/login/'>
              login
            </Link> to submit a review.
          </small>
        ) }

        <ReviewList
          loading={loading}
        >
          { children }
        </ReviewList>

      </div>

    </section>
  );
};

Reviews.propTypes = {
  canReview: PropTypes.bool,
  children: PropTypes.node,
  isLoggedIn: PropTypes.bool,
  loading: PropTypes.bool,
  numReviews: PropTypes.number,
  reviewForm: PropTypes.node.isRequired,
};

Reviews.defaultProps = {
  canReview: null,
  children: null,
  isLoggedIn: false,
  loading: false,
  numReviews: null,
};

export default Reviews;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Reviews/index.jsx